import { useEffect } from "react";
import { Redirect, useLocation, useParams } from "react-router";
import { Box } from "@mui/material";
import { Form, Formik, FormikHelpers } from "formik";

import { PanelDetailContent as RightContent } from "components/PanelDetailContent";
import { PanelSidebar } from "components/PanelSidebar";
import Page from "components/wrappers/Page";
import { CUSTOM_PANELS } from "helpers/apis";
import useCatalog from "hooks/useCatalog";
import useCatalogDetail from "hooks/useCatalogDetail";
import { IDesign } from "types/design";
import { ICustomPanelForm } from "types/form";

import { validationSchema } from "./index";

const CustomPanel = ({ customize = false }: { customize?: boolean }) => {
  const { id: customPanelId } = useParams<{ id: string }>();
  const { getCustomPanelById } = useCatalog();
  const { pathname } = useLocation();
  const {
    catalog: storeCatalog,
    customPanelAction,
    fetchDesignDetails,
    setCatalog,
    setCustomize,
    setDraftSaved,
    setIsCustomPanel,
  } = useCatalogDetail();
  let customPanel: (IDesign & { panelspresent?: any }) | undefined =
    getCustomPanelById(Number(customPanelId));

  useEffect(() => {
    if (
      !!customPanel &&
      Array.isArray(customPanel.panelspresent) &&
      !!customPanel.panelspresent.length
    ) {
      // Set new details for custom panels
      fetchDesignDetails(
        customPanel.panelspresent.map((item: any) => {
          return {
            panelId: item.design,
            cnv: item.cnv,
          };
        })
      );
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [customPanel, fetchDesignDetails]);

  useEffect(() => {
    setCustomize(customize);
    setIsCustomPanel(true);
    setCatalog(customPanel);
    setDraftSaved(customPanel?.draftSaved);
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [pathname]);

  if (!customPanel) {
    return <Redirect to="/" />;
  }
  if (!storeCatalog || customPanel.id !== storeCatalog.id) {
    return <></>;
  }

  const onSubmit = (
    values: ICustomPanelForm,
    actions: FormikHelpers<ICustomPanelForm>
  ) => {
    customPanelAction({
      values,
      actions,
      config: {
        url: customize ? `${CUSTOM_PANELS}${customPanel?.id}/` : CUSTOM_PANELS,
        method: customize ? "PUT" : "POST",
      },
    });
  };

  return (
    <Box width={1}>
      <Formik
        initialValues={{
          panelName: customPanel.name || "",
          panels: [],
          ...(typeof customPanel.hasMsi === "boolean" && {
            msi: customPanel.hasMsi,
          }),
          ...(typeof customPanel.hasMsi === "boolean" && {
            snpId: customPanel.hasSnpId,
          }),
        }}
        enableReinitialize
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <Form>
          <Page>
            <PanelSidebar />
            <RightContent />
          </Page>
        </Form>
      </Formik>
    </Box>
  );
};

export default CustomPanel;
